module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/catServiceOne-e4b5968a38a735626d0b310860ab94cf.svg";